"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css = require("@emotion/css");
var _loader = _interopRequireDefault(require("@amzn/meridian-tokens/component/loader"));
var _linear = _interopRequireDefault(require("./_linear"));
var _circular = _interopRequireDefault(require("./_circular"));
var _theme = require("../theme");
var _text = _interopRequireDefault(require("./../_styles/text"));
var _clamp = _interopRequireDefault(require("./../_utils/clamp"));
var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var wrapperStyles = function wrapperStyles(t, _ref) {
  var type = _ref.type,
    size = _ref.size;
  return (0, _css.css)((0, _text["default"])(t, {
    fontSize: type === "linear" ? type : size,
    lineHeight: type === "linear" ? type : size,
    fontWeight: "body"
  }));
};
var createFormatter = function createFormatter(locale) {
  return new Intl.NumberFormat(locale, {
    style: "percent"
  });
};
var Loader = function Loader(props) {
  var size = props.size,
    type = props.type,
    showPercentageText = props.showPercentageText,
    label = props.label,
    locale = props.locale;
  var t = (0, _theme.useTheme)(_loader["default"], "loader");
  var percentFormatter = (0, _react.useRef)(createFormatter(locale));
  var percentage = props.percentage === undefined ? undefined : (0, _clamp["default"])(props.percentage, 0, 100);
  var determinate = percentage !== undefined;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  var formattedPercent = determinate ? percentFormatter.current.format(percentage / 100) : null;
  var LoaderComponent = type === "linear" ? _linear["default"] : _circular["default"];
  var loaderProps = {
    label: label,
    percentage: percentage,
    showPercentageText: showPercentageText,
    size: size,
    determinate: determinate,
    t: t,
    children: formattedPercent
  };
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, {
    className: wrapperStyles(t, {
      size: size,
      type: type
    })
  }), /*#__PURE__*/_react["default"].createElement(LoaderComponent, loaderProps));
};
Loader.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   */
  "aria-*": _propTypes["default"].string,
  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,
  /**
   * An accessible label. This is not shown in the UI, but will be read by
   * screen-readers.
   */
  label: _propTypes["default"].string,
  /**
   * The locale used to format the percentage. Any local supported by
   * the [Number.toLocaleString API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString)
   * will work.
   */
  locale: _propTypes["default"].string,
  /**
   * Set this to a number between `0` and `100` (inclusive) to show the loader
   * at a particular stage of completion.
   *
   * If this prop is not set the loader will indicate an "indefinite" loading
   * state using a cyclical animation.
   */
  percentage: _propTypes["default"].number,
  /**
   * This determines whether the value of the `percentage` prop is shown in
   * text-form in the UI.
   */
  showPercentageText: _propTypes["default"].bool,
  /**
   * Sets the size of the component using a preset.
   *
   * The `"medium"` sizes is only available if `type` is set to `"circular"`.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large"]),
  /**
   * Determines the shape of the loader.
   */
  type: _propTypes["default"].oneOf(["circular", "linear"])
} : {};
Loader.defaultProps = {
  size: "large",
  type: "circular",
  showPercentageText: true
};
var _default = Loader;
exports["default"] = _default;